import { render, staticRenderFns } from "./TouristInfoBaseForm.vue?vue&type=template&id=761d4546&scoped=true&"
import script from "./TouristInfoBaseForm.vue?vue&type=script&lang=js&"
export * from "./TouristInfoBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d4546",
  null
  
)

export default component.exports